export default __webpack_public_path__ + "74f84d8bc06e43978ae8b6151fe7d5bc.svg";